import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articles';

export default function SugargooQcGuidePage() {
  const article = allArticles.find(a => a.slug === 'sugargoo-qc-guide')!;
  return <ArticleLayout article={article} />;
}